const e = {
  size: "medium"
};
export { e as checkboxDefaultProps };